import { inject } from "@angular/core";
import { signalStore, withMethods, patchState } from "@ngrx/signals";
import { withEntities, setAllEntities } from "@ngrx/signals/entities";
import { Observable, tap } from "rxjs";
import { ApiOffersService } from "../../services/api-offers.service";
import { withRequestStatus } from "../extensions/request-status.feature";
import { OfferStatisticPreviewViewModel } from "@playcharge/common/models/backend/offers/backoffice/offer-statistic-preview-view-model";
import { DateTime } from "luxon";

export type OfferStatisticsStore = InstanceType<typeof OfferStatisticsStore>;

export const OfferStatisticsStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<OfferStatisticPreviewViewModel>(),
    withRequestStatus(),
    withMethods((store, apiOffersService = inject(ApiOffersService)) => ({
        getStatistics(
            startDate: DateTime,
            endDate: DateTime,
        ): Observable<OfferStatisticPreviewViewModel[]> {
            return apiOffersService.getStatisticsByRange(startDate, endDate).pipe(
                tap((offers) => {
                    patchState(
                        store,
                        setAllEntities(offers, { selectId: (offer) => offer.offerId }),
                    );
                }),
            );
        },
    })),
);
